import { Link, useParams, useSearchParams } from 'react-router-dom';

import { Carregando, Falha } from '@/componentes/estado-da-tela';
import { Button } from '@/componentes/ui/button';
import { mensagemDoErro, useEmpresaAdmin } from '@/dados';
import { Pagina } from '@/layout/pagina';
import { SoAdmin } from '@/telas/admin/guarda';

import { Analises } from './analises';
import { Cadastro } from './cadastro';
import { Custos } from './custos';
import { DespesasDaEmpresa } from './despesas';
import { Email } from './email';
import { Exclusao } from './exclusao';
import { Projetos } from './projetos';
import { SazonalidadeDaEmpresa } from './sazonalidade';
import { Visitas } from './visitas';

/* Uma empresa por inteiro. Este arquivo só decide O QUE mostrar.
 *
 * A ordem é a mesma do funil que a empresa percorreu: quem ela é, o que
 * configurou, o que orçou, o que arquivou, quando apareceu. As duas ações do
 * administrador ficam nas pontas, o e-mail junto do cadastro que ele corrige e
 * a exclusão no fim, longe do primeiro clique.
 *
 * O endereço da lista viaja na querystring e volta no botão: quem abriu o
 * quinto nome de uma busca não pode ter de refazer a busca para ver o sexto. */
export function EmpresaDoPainel() {
  const { id = '' } = useParams();
  const [parametros] = useSearchParams();
  const detalhe = useEmpresaAdmin(id || null);

  return (
    <SoAdmin>
      <Pagina
        titulo={detalhe.data?.cadastro.nome_empresa ?? 'Empresa'}
        descricao="Cadastro, configuração, trabalho feito e visitas."
        acoes={
          <Button variant="outline" asChild>
            <Link to={{ pathname: '/admin', search: parametros.toString() }}>Voltar à lista</Link>
          </Button>
        }
      >
        {detalhe.isError ? (
          <Falha
            oQue="a empresa"
            motivo={mensagemDoErro(detalhe.error)}
            aoTentarDeNovo={() => void detalhe.refetch()}
          />
        ) : !detalhe.data ? (
          <Carregando linhas={3} rotulo="Carregando a empresa." />
        ) : (
          <>
            <Cadastro cadastro={detalhe.data.cadastro} />
            {/* `key` no e-mail gravado: o campo NASCE com o valor e volta a
                nascer quando a troca é confirmada pelo servidor. */}
            <Email key={detalhe.data.cadastro.email} id={id} email={detalhe.data.cadastro.email} />
            <Custos configs={detalhe.data.cadastro.configs} />
            <DespesasDaEmpresa despesas={detalhe.data.cadastro.despesas} />
            <SazonalidadeDaEmpresa sazonalidade={detalhe.data.cadastro.sazonalidade} />
            <Projetos projetos={detalhe.data.projetos} />
            <Analises
              orcamentos={detalhe.data.orcamentos}
              diagnosticos={detalhe.data.diagnosticos}
            />
            <Visitas acessos={detalhe.data.acessos} />
            <Exclusao
              id={id}
              nome={detalhe.data.cadastro.nome_empresa}
              quantidades={{
                projetos: detalhe.data.projetos.length,
                analises: detalhe.data.orcamentos.length + detalhe.data.diagnosticos.length,
                visitas: detalhe.data.cadastro.acessos,
              }}
            />
          </>
        )}
      </Pagina>
    </SoAdmin>
  );
}
